<p-toast></p-toast>
<div class="card dpm-card w-100 p-3">
    <div id="divID" style="overflow-x:auto;">
        <table class="table table-bordered" style="border-bottom: 1px solid;">
            <thead style="text-align: center;">
                <tr>
                    <th colspan="1">FailureMode Id</th>
                    <th colspan="2">Asset Name</th>
                    <th colspan="1">Failure Mode</th>
                    <th colspan="2">Batch Description</th>
                    <th colspan="2">DateTime of BatchUploaded</th>
                    <th colspan="2">DateTime of BatchCompleted</th>
                    <th colspan="1">Details</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let b of batch; let i = index">
                    <td colspan="1">{{b.Id}}</td>
                    <td colspan="2">{{b.Asset}}</td>
                    <td colspan="1">{{b.FailureModeName}}</td>
                    <td colspan="2">{{b.Description}}</td>
                    <td colspan="2">{{b.DateTimeBatchUploaded}}</td>
                    <td colspan="2">{{b.DateTimeBatchCompleted}}</td>
                    <td colspan="1"><button class="btn btn-info" (click)="Show(b.Id)"><i class="pi pi-eye ">{{StatusShow}}</i></button></td>
                </tr>
            </tbody>
        </table>
    </div>
    <br><br>
    <div *ngIf="show">
        <h3>Details of selected batch :</h3> <br>
        <div *ngFor="let l of list">
            <div *ngIf="Id===l[0]">
                <span><b> FailureMode Id </b> : {{l[0]}}</span><br>
                <span><b> Asset Name </b> : {{l[1]}}</span><br>
                <span><b> Failure Mode Name </b> : {{l[2]}}</span><br>
                <span><b> Staging Count </b> : {{l[3]}}</span><br>
                <span><b> Cleaning Count </b> : {{l[4]}}</span><br>
                <span><b> Errors </b> :</span><br>
                <div *ngIf="noError">
                    &nbsp;&nbsp;<span>No errors</span><br>
                </div>
                <div *ngFor="let e of l[5];">
                    &nbsp;&nbsp;<span>Id : {{e.Id}}</span><br>
                    &nbsp;&nbsp;<span>Description : {{e.Description}}</span><br>
                    &nbsp;&nbsp;<span>Row Affected : {{e.rowAffected}}</span><br><br>
                </div><br>
                <span><b> ProcessedValues Count </b> : {{l[6]}}</span><br>
                <span><b> PredictedValues Count </b> : {{l[7]}}</span><br>
            </div>
        </div>
    </div>
</div>
